module.exports = __webpack_public_path__ + "static/media/G2B.3c4084fa.png";